export default "__VITE_ASSET__CbtiBXR$__"